export const theme = {
  colors: {
    gray: {
      gray100: '#FFFFFF',
      gray200: '#F6F6F6',
      gray300: '#E6E6E6',
      gray400: '#CCCCCC',
      gray500: '#B3B3B3',
      gray600: '#999999',
      gray700: '#808080',
      gray800: '#666666',
      gray900: '#4D4D4D',
      gray1000: '#333333',
      gray1100: '#1A1A1A',
    },
    blue: {
      blue100: '#F4F7FF',
      blue200: '#E5ECFF',
      blue300: '#CCDAFF',
      blue400: '#99B5FF',
      blue500: '#6690FF',
      blue600: '#336BFF',
    },
    purple: {
      purple100: '#F3F2FF',
      purple200: '#E6E5FF',
      purple300: '#CDCCFF',
      purple400: '#B4B2FF',
      purple500: '#8280FF',
      purple600: '#3733FF',
      purple700: '#2C29CC',
      purple800: '#1E1B99',
      purple900: '#161466',
    },
    red: {
      red100: '#FFE2EC',
      red200: '#FF2070',
    },
    yellow: {
      yellow100: '#FFFEE5',
      yellow200: '#FFFB99',
      yellow300: '#FFF733',
    },
  },
  profileColor: {
    blue1: '#94B8FF',
    blue2: '#E8E9FF',
    blue3: '#59AFFF',
    blue4: '#DFF0FF',
    blue5: '#8C94BF',
    blue6: '#CFFFFF',
    blue7: '#6285FF',
    blue8: '#B2D6FF',
  },
  fontStyles: {
    display: {
      displayRegular: `
        font-family: "Pretendard-Regular";
        font-size: 4rem;
        line-height: 140%;
    `,
    },
    headline: {
      headlineRegular: `
        font-family: "Pretendard-Regular";
        font-size: 2.4rem;
        line-height: 140%;
    `,
      headlineBold: `
        font-family: "Pretendard-SemiBold";
        font-size: 2.4rem;
        line-height: 155%;
    `,
      headlineMedium: `
        font-family: "Pretendard-Regular";
        font-size: 2.4rem;
        line-height: 155%;
    `,
    },
    title: {
      titleRegular: `
        font-family: "Pretendard-Regular";
        font-size: 2rem;
        line-height: 140%;
    `,
      titleBold: `
        font-family: "Pretendard-Medium";
        font-size: 2rem;
        line-height: 140%;
    `,
      titleMedium: `
        font-family: "Pretendard-Medium";
        font-size: 2rem;
        line-height: 160%;
    `,
    },
    subtitle: {
      subtitleRegular: `
        font-family: "Pretendard-Regular";
        font-size: 1.6rem;
        line-height: 155%;
    `,
      subtitleBold: `
        font-family: "Pretendard-Bold";
        font-size: 1.6rem;
        line-height: 155%;
    `,
      subtitleSemibold: `
        font-family: "Pretendard-SemiBold";
        font-size: 1.6rem;
        line-height: 155%;
    `,
      subtitleMedium: `
        font-family: "Pretendard-Medium";
        font-size: 1.6rem;
        line-height: 155%;
    `,
    },
    body: {
      bodyRegular: `
        font-family: "Pretendard-Regular";
        font-size: 1.4rem;
        line-height: 160%;
    `,
      bodyBold: `
        font-family: "Pretendard-Bold";
        font-size: 1.4rem;
        line-height: 160%;
    `,
      bodySemibold: `
        font-family: "Pretendard-SemiBold";
        font-size: 1.6rem;
        line-height: 155%;
    `,
      bodyMedium: `
        font-family: "Pretendard-Medium";
        font-size: 1.6rem;
        line-height: 155%;
    `,
    },
    caption: {
      captionRegular: `
        font-family: "Pretendard-Regular";
        font-size: 1.2rem;
        line-height: 160%;
    `,
      captionSemibold: `
        font-family: "Pretendard-SemiBold";
        font-size: 1.2rem;
        line-height: 160%;
    `,
      captionSmall: `
        font-family: "Pretendard-Regular";
        font-size: 1rem;
        line-height: 155%;
    `,
    },
    button: {
      buttonLarge: `
        font-family: "Pretendard-SemiBold";
        font-size: 1.8rem;
        line-height: 160%;
    `,
    },
  },
};
